<template>
  <div class="addDevice">
    <!--        <el-breadcrumb separator-class="el-icon-arrow-right">-->
    <!--            <el-breadcrumb-item :to="{ path: 'mybankcard' }">我的银行卡</el-breadcrumb-item>-->
    <!--            <el-breadcrumb-item>添加银行卡</el-breadcrumb-item>-->
    <!--        </el-breadcrumb>-->
    <!--        <el-divider />-->
    <div class="main fc ac jc pt30 pr30 pl30">
      <el-form
          :model="form"
          ref="form"
          :rules="rules"
          style="width:80%"
          label-width="120px"
          label-position="right"
      >
        <el-form-item label="持卡人姓名" prop="bank_holder_name">
          <el-input type="text" v-model="form.bank_holder_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="发卡银行" prop="bank_name">
          <el-input type="text" v-model="form.bank_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号" prop="bank_no">
          <el-input type="text" v-model="form.bank_no" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="预留手机号" prop="bank_mobile">
          <el-input type="text" v-model="form.bank_mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    var checkbank_no = (rule, value, callback) => {
      if (this.checkback(value)) {
        callback();
      } else {
        callback(new Error("银行卡号输入不正确"));
      }
    };
    var checkPhone = (rule, value, callback) => {
      if (this.checkPhone(value)) {
        callback();
      } else {
        callback(new Error("手机号输入不正确"));
      }
    };
    return {
      form: {
        bank_holder_name: "",
        bank_name: "",
        bank_no: "",
        bank_mobile: "",
        bank_mobile: ""
      },
      rules: {
        bank_holder_name: [
          {
            required: true,
            message: "请输入持卡人姓名",
            trigger: "blur"
          }
        ],
        bank_name: [
          {
            required: true,
            message: "请输入发卡银行",
            trigger: "blur"
          }
        ],
        bank_no: [
          {
            required: true,
            message: "请输入银行卡号",
            trigger: "blur"
          },
          {validator: checkbank_no, trigger: "blur"}
        ],
        bank_mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {validator: checkPhone, trigger: "blur"}
        ]
      }
    };
  },
  computed: {},
  created() {
  },
  watch: {},
  methods: {
    submitForm() {
      let ok = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          ok = false;
        }
      });
      if (!ok) return;
      this.post("bankInterfaces/v1.0/insertMemberBank", this.form).then(
          res => {
            this.$message({
              type: "success",
              message: "银行卡添加成功"
            });
            this.$emit('success')
          }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.addDevice {
  font-size: 14px;

  .main {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/BankCard/add.vue